import styled from 'styled-components';
import { COLORS } from 'Permafrost/constants';
export const StyledFilterSelect = styled.div `
  border: 1px solid ${COLORS.oxfordBlue};
  border-radius: 3px;
  display: inline-block;
  margin: 0 var(--pf-padding-2) var(--pf-padding-2) 0;
  position: relative;

  .FilterSelect__toggle {
    display: flex;
    align-items: center;
    background-color: ${COLORS.ebony};
    color: ${COLORS.midFontColor};
    height: 35px;
    padding: 5px 10px;
    box-shadow: none;

    .filter-label {
      margin-right: var(--pf-padding-2);
    }

    &:hover {
      color: ${COLORS.lightFontColor};
    }
  }

  .swatch-circle {
    position: absolute;
    top: -3px;
    right: -3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--pf-secondary-color-400);
  }

  .filter__container {
    position: absolute;
    top: 36px;
    ${({ $placement }) => ($placement === 'left' ? 'right: 0;' : 'left: 0;')}
    width: 275px;
    background-color: ${COLORS.midnight};
    border: 1px solid ${COLORS.comet};
    border-radius: 4px;
    color: ${COLORS.lightFontColor};
    display: none;
    z-index: 100;
  }

  .visible {
    display: block;
  }

  .FilterSelect__options {
    padding: var(--pf-padding-3) 0;
  }

  .filter__title,
  .option-container:not(:last-child) {
    margin-bottom: var(--pf-padding-2);
  }

  .filter__icon {
    margin-left: var(--pf-padding-2);
  }

  .filter__check {
    margin-right: var(--pf-padding-2);
  }
`;
//# sourceMappingURL=FilterSelect.styles.js.map